{
  "BUSINESS_NUMBER": {
    "TITLE": "Renseignez votre numéro d'affaire pour démarrer",
    "INSTRUCTION_FORMAT": "Format : 7 chiffres minimum.",
    "PLACEHOLDER": "Ex : 1234567",
    "ERROR_INVALID_FORMAT": "Le numéro d'affaire doit contenir au moins 7 chiffres."
  },
  "BUTTON": {
    "VALIDATE": "Valider",
    "VALIDATE_MY_CHOICES": "Valider mes choix"
  },
  "CONFIRM_DIALOG": {
    "VALIDATE": "Valider",
    "CANCEL": "Abandonner"
  },
  "FOOTER": {
    "COPYRIGHT_NOTICE": "© {{ year }} EVOQ {{ brandLabel }}. Tous droits réservés."
  },
  "FREE_ROAM": {
    "CREATIVE_SUGGESTION": "Pour modifier votre scène 3D et obtenir un visuel ultra-réaliste, vous pourriez envisager d'ajouter des éléments spécifiques tels que : une pièce annexe, un style, des éléments de décoration, un moment de la journée… Faites parler votre créativité !",
    "TYPE_TEXT_HERE": "Taper votre texte ici (100 caractères minimum)",
    "VISUAL_IMPROVEMENT_DESCRIPTION": "Veuillez décrire les améliorations que vous souhaitez apporter à votre visuel"
  },
  "GENERATION_RESULT": {
    "COPIED_CONFIRMATION": "Copié !",
    "COPY_PROMPT": "Copier le prompt",
    "ENLARGE_IMAGE": "Agrandir",
    "DOWNLOAD_IMAGE": "Télécharger l'image",
    "DOWNLOAD_VIDEO": "Télécharger la vidéo",
    "EDIT_PROMPT": "Éditer le prompt",
    "EVOQ_PROPOSED_VISUAL": "Voici le visuel proposé par Evoq",
    "EVOQ_PROPOSED_VISUALS": "Voici les visuels proposés par Evoq",
    "GENERATE_VIDEO": "Générer la vidéo",
    "GENERATION_ERROR_RETRY": "Une erreur est survenue lors de la génération. Veuillez réessayer.",
    "SERVER_BUSY_ERROR": "Nos serveurs sont très sollicités en ce moment. Veuillez réessayer dans quelques instants.",
    "RETRY_ACTION": "Réessayer",
    "PROCESSING_VIDEOS_COUNT": "{{ processingVideoCount }} vidéos en cours",
    "REGENERATE_ACTION": "Regénérer",
    "REMAINING_IMAGES": "Images restantes :",
    "REMAINING_VIDEOS": "Vidéos restantes :",
    "VIDEO_CREATION_IN_PROGRESS": "Vidéo en cours de création",
    "WAIT_MOMENT_MESSAGE": "Veuillez patienter un instant..."
  },
  "GUIDED_TOUR": {
    "ANSWER": {
      "ROOM_BATHROOM": "La salle de bains",
      "ROOM_BEDROOM": "La chambre",
      "ROOM_DINING": "La salle à manger",
      "ROOM_DRESSING": "Le dressing",
      "ROOM_ENTRANCE": "L'entrée",
      "ROOM_KITCHEN": "La cuisine",
      "ROOM_LAUNDRY": "La buanderie",
      "ROOM_LIVING": "Le salon",
      "ROOM_NO": "Non",
      "ROOM_OFFICE": "Le bureau",
      "ROOM_PANTRY": "Le cellier",
      "STYLE_CONTEMPORARY": "Contemporain",
      "STYLE_COUNTRY": "Campagne",
      "STYLE_COZY": "Cosy",
      "STYLE_DESIGN": "Design",
      "STYLE_HIGH_END": "Haut de gamme",
      "STYLE_INDUSTRIAL": "Industriel",
      "STYLE_MODERN": "Moderne",
      "STYLE_RUSTIC": "Rustique",
      "STYLE_SCANDINAVIAN": "Scandinave",
      "STYLE_WOOD": "Bois",
      "TIME_AFTERNOON": "L'après-midi",
      "TIME_EVENING": "Le soir",
      "TIME_MORNING": "Le matin",
      "TIME_NONE": "Aucun",
      "TIME_NOON": "Le midi"
    },
    "FORM": {
      "ENTER_ELEMENT": "Saisir un élément"
    },
    "QUESTION": {
      "ADJOINING_ROOM": "Souhaitez-vous inclure une pièce annexe dans votre plan principal ?",
      "APPLY_STYLE": "Quel style souhaitez-vous appliquer à votre scène ?",
      "DECORATION_ELEMENTS": "Quels sont les éléments essentiels de décoration à ajouter ?",
      "MAIN_ROOM_SELECTION": "Quelle est la pièce principale que vous souhaitez traiter ?",
      "TIME_OF_DAY": "À quel moment de la journée souhaitez-vous faire référence ?"
    }
  },
  "HEADER": {
    "BUDGET_THIS_MONTH": "Budget consommé ce mois-ci (estimation)",
    "DASHBOARD": "Tableau de bord",
    "FREE_CREDITS": "Crédits gratuits",
    "FREE_CREDITS_LABEL": "crédits gratuits",
    "IMAGES_THIS_MONTH": "Images générées ce mois-ci",
    "LOGOUT": "Déconnexion",
    "NEW_PROJECT": "Nouveau projet",
    "THIS_MONTH": "Ce mois-ci",
    "VIDEOS_THIS_MONTH": "Vidéos générées ce mois-ci"
  },
  "IMAGE_UPLOAD": {
    "ACCEPTED_FORMATS": "Formats acceptés : PNG ou JPEG.",
    "ALL_CREDITS_USED": "Vous avez utilisé tous vos crédits",
    "BLOCKED_GENERIC": "La génération d'image est momentanément indisponible.",
    "BLOCKED_NO_QUOTA": "Aucun quota Evoq n'est défini pour votre compte.",
    "BLOCKED_QUOTA_MONTHLY": "Votre quota Evoq mensuel est épuisé. Rapprochez-vous de votre responsable.",
    "BLOCKED_QUOTA_ROLLING": "Votre quota Evoq est épuisé.",
    "BLOCKED_QUOTA_ROLLING_UNTIL": "Votre quota Evoq est épuisé. Vous pourrez générer à nouveau le {{ date }}.",
    "BLOCKED_UNAVAILABLE": "Indisponible",
    "CATALOG_ONLY_NOTICE": "Remarque : Tout élément présent dans votre scène ne sera pas transformé par l'IA mais amélioré pour obtenir un rendu réaliste.",
    "FILE_SIZE_LIMIT": "La taille du fichier ne doit pas dépasser {{ size }} Mo",
    "FREE_IMAGE_GENERATION": "Génération d'image libre",
    "GUIDED_IMAGE_GENERATION": "Génération d'image guidée",
    "IMPORT_ROOM_VISUAL": "Importer votre visuel",
    "INSUFFICIENT_DIMENSIONS": "Dimensions insuffisantes (min. {{ minWidth }} x {{ minHeight }} px)",
    "INVALID_FORMAT": "Format invalide (PNG ou JPEG uniquement)",
    "LIGHTING_WARNING": "<strong>Important :</strong> utilisez un plan sans jeux de lumière afin d'éviter toute hallucination de l'IA.",
    "MINIMUM_IMAGE_DIMENSIONS": "Dimensions minimales de l’image à télécharger : {{ minWidth }} x {{ minHeight }} pixels.",
    "NO_MORE_CREDIT": "Plus de crédit",
    "UNREADABLE_FILE": "Impossible de lire le fichier",
    "UPLOAD_ROOM_VISUAL": "Charger le visuel de votre pièce pour commencer"
  },
  "LOGIN": {
    "AUTHENTICATING_MESSAGE": "Veuillez patienter pendant que nous récupérons vos informations...",
    "AUTHENTICATING_TITLE": "Authentification en cours",
    "AUTO_LOGIN_FOURNIER": "Connexion automatique Fournier",
    "AUTO_LOGIN_FRANCHISEE": "Connexion automatique Franchisé",
    "CHOOSE_SPACE_INSTRUCTION": "Choisissez votre espace pour continuer",
    "ERROR_FRANCHISE_MISSING_STORE_MESSAGE": "Votre compte n'est pas rattaché à un magasin. Veuillez créer un Ticket Easy Vista afin de compléter cette information et réessayer.",
    "ERROR_FRANCHISE_MISSING_STORE_TITLE": "Connexion impossible",
    "ERROR_MESSAGE": "Une erreur est survenue lors de la récupération de vos informations. Veuillez réessayer.",
    "ERROR_TITLE": "Échec de l'authentification",
    "RETRY_BUTTON": "Réessayer",
    "WELCOME_MESSAGE": "Bienvenue sur Evoq"
  },
  "DASHBOARD": {
    "TITLE": "Dashboard",
    "NAV": {
      "OVERVIEW": "Aperçu",
      "VENDORS": "Équipe",
      "BILLING_HISTORY": "Historique de facturation"
    },
    "OVERVIEW": {
      "TITLE": "Aperçu",
      "MANAGE": "Gérer",
      "PLACEHOLDER": {
        "TITLE": "Bientôt disponible",
        "DESCRIPTION": "L'aperçu de votre activité est en cours de refonte."
      }
    },
    "VENDORS": {
      "TITLE": "Gestion de l'équipe",
      "PHYSICAL": {
        "SUBTITLE": "Activez ou résiliez l'abonnement de chaque vendeur de votre équipe.",
        "COUNTER_ACTIVE": "Abonnés actifs",
        "COUNTER_NONE": "Sans abonnement",
        "COUNTER_CANCELLING": "Résil. programmée",
        "TABLE_TITLE": "Vendeurs",
        "COST_HINT": "Coût de l'abonnement : {{price}} / mois / vendeur",
        "COST_UNAVAILABLE": "Tarifs indisponibles",
        "COL_VENDOR": "Vendeur",
        "COL_STATUS": "Statut",
        "COL_ACTION": "Action",
        "SELECT_ALL": "Tout sélectionner",
        "SELECT_ROW": "Sélectionner {{name}}",
        "SELECT_ROW_DISABLED": "{{name}} ne peut pas être sélectionné",
        "STATUS_SUBSCRIBED": "Abonné",
        "STATUS_NONE": "Sans abonnement",
        "STATUS_CANCELLING": "Résiliation programmée",
        "CANCELLING_EFFECT": "Effet le {{date}}",
        "FREE_CREDITS": "Crédits gratuits : {{count}} / {{total}} restants",
        "ACTION_ACTIVATE": "Activer l'abonnement",
        "ACTION_CANCEL": "Résilier",
        "ACTION_REACTIVATE": "Annuler la résiliation",
        "SELECTED_ONE": "vendeur sélectionné",
        "SELECTED_OTHER": "vendeurs sélectionnés",
        "BULK_ACTIVATE": "Activer l'abonnement",
        "BULK_CLEAR": "Tout désélectionner",
        "EMPTY": "Aucun vendeur dans cette équipe.",
        "LOADING": "Chargement...",
        "ENGAGEMENT_NOTE": "Abonnement engagé jusqu'à la fin du trimestre civil, reconduit automatiquement chaque trimestre sauf résiliation ; celle-ci prend effet en fin de trimestre.",
        "CONFIRM_ACTIVATE_TITLE": "Activer l'abonnement",
        "CONFIRM_ACTIVATE_BODY": "{{name}}, {{price}} / mois. Abonnement engagé jusqu'à la fin du trimestre civil, reconduit ensuite chaque trimestre sauf résiliation.",
        "CONFIRM_ACTIVATE_OK": "Activer",
        "DESK_REQUEST_TITLE": "Pour activer un abonnement, faites une demande via un ticket Desk",
        "DESK_REQUEST_PATH": "Desk → Déclarer un ticket Desk Fournier Retail, Rubrique \"Service\"",
        "DESK_CLOSE": "Fermer",
        "CANCEL": "Annuler",
        "CONFIRM_CANCEL_TITLE": "Résilier l'abonnement",
        "CONFIRM_CANCEL_BODY": "Effet le {{date}} (fin du trimestre en cours). {{name}} garde l'accès jusque-là.",
        "CONFIRM_CANCEL_OK": "Résilier",
        "CONFIRM_REACTIVATE_TITLE": "Annuler la résiliation",
        "CONFIRM_REACTIVATE_BODY": "L'abonnement de {{name}} se poursuivra normalement.",
        "CONFIRM_REACTIVATE_OK": "Confirmer",
        "CONFIRM_REACTIVATE_BACK": "Retour",
        "BULK_CONFIRM": "Confirmer l'activation",
        "BULK_UNIT_COST": "Coût unitaire",
        "BULK_ENGAGEMENT": "Engagement",
        "BULK_ENGAGEMENT_VALUE": "Jusqu'à la fin du trimestre",
        "BULK_TOTAL": "Total mensuel",
        "TOAST_ACTIVATED": "Abonnement activé pour {{name}}",
        "TOAST_CANCELLED": "Résiliation programmée pour {{name}}",
        "TOAST_REACTIVATED": "Résiliation annulée pour {{name}}",
        "TOAST_BULK_ONE": "Abonnement activé pour 1 vendeur",
        "TOAST_BULK_OTHER": "Abonnement activé pour {{count}} vendeurs",
        "TOAST_ERROR": "Une erreur est survenue, veuillez réessayer."
      }
    },
    "BILLING_HISTORY": {
      "TITLE": "Historique de facturation",
      "BADGE": "abonnements",
      "INTRO": "Facturation des abonnements de votre équipe, facturée au mois et regroupée par trimestre. Pour chaque mois : le nombre d'abonnements actifs et le coût correspondant.",
      "KPI_TOTAL_YEAR": "Total {{ year }}",
      "KPI_TOTAL_YEAR_TO_DATE": "Total {{ year }} à ce jour",
      "KPI_CURRENT_QUARTER": "Trimestre en cours",
      "KPI_LAST_QUARTER": "Dernier trimestre",
      "CARD_TITLE": "Facturation mensuelle",
      "YEAR_SELECTOR_LABEL": "Choix de l'année",
      "STATUS_IN_PROGRESS": "Trimestre en cours",
      "STATUS_CHARGED": "Facturé",
      "SUBTOTAL": "Sous-total",
      "TOTAL": "Total",
      "NOTE": "Facture mensuelle, émise pour le mois écoulé et regroupée par trimestre civil (T1 janv.-mars, T2 avr.-juin, T3 juil.-sept., T4 oct.-déc.). Tout abonnement actif dans le mois est facturé au mois entier, sans prorata. Le tarif et le coût mensuel sont fournis par la facturation."
    },
    "CONSUMPTION": {
      "TITLE": "Consommation de l'équipe",
      "VENDOR": "Membre",
      "IMAGE": "Image",
      "VIDEO": "Vidéo",
      "REMAINING": "Reste: {{ value }}",
      "REMAINING_WITH_FREE": "Reste: {{ total }} dont {{ free }} gratuits",
      "NO_VENDORS": "Aucun membre pour le moment"
    },
    "ALLOCATION": {
      "CANNOT_GENERATE": "Ne peut pas générer",
      "QUOTA_HIDDEN_NOTICE": "Le quota est défini ici par le manager. Côté utilisateur, il reste invisible : le vendeur ne voit que sa consommation et son budget.",
      "IMAGE_QUOTA": "Quota Image",
      "VIDEO_QUOTA": "Quota Vidéo",
      "APPLY": "Appliquer",
      "SAVING": "Sauvegarde...",
      "SAVE_QUOTAS": "Enregistrer les quotas",
      "SAVE_SUCCESS": "Les quotas ont été mis à jour avec succès",
      "IMAGE": "Image",
      "VIDEO": "Vidéo",
      "CONSUMPTION": "Conso",
      "MONTHLY_QUOTA": "Quota Mensuel",
      "FREE_CREDITS": "Gratuits",
      "REMAINING": "Reste: {{ value }}"
    },
    "PACKS": {
      "FILTER_ALL": "Tous",
      "FILTER_IMAGES": "Images",
      "FILTER_VIDEOS": "Vidéos",
      "FILTER_MIXED": "Mixtes",
      "PRICE_PER_IMAGE": "Soit {{ price }} par image",
      "PRICE_PER_VIDEO": "Soit {{ price }} par vidéo",
      "CREDITS": "Crédits",
      "IMAGES": "Images",
      "VIDEO": "Vidéo",
      "CHOOSE_PACK": "Choisir ce pack"
    },
    "BILLING_HISTORY_TABLE": {
      "MONTH": "Mois",
      "ACTIVE_SUBSCRIPTIONS": "Abonnements actifs",
      "MONTHLY_COST": "Coût mensuel",
      "EMPTY_TITLE": "Aucune facturation",
      "EMPTY_MESSAGE": "L'historique de facturation de vos abonnements apparaîtra ici."
    },
    "USAGE_HISTORY": {
      "BADGE": "par utilisateur",
      "INTRO": "Consommation mensuelle par utilisateur et coût correspondant.",
      "KPI_TOTAL_MONTH": "Total",
      "KPI_LAST_3_MONTHS": "3 derniers mois",
      "NOTE": "Consommation facturée au trimestre (mois en cours et les deux précédents). Le coût de chaque mois est figé au moment de la consommation."
    },
    "USAGE_HISTORY_TABLE": {
      "CARD_TITLE": "Détail par utilisateur",
      "USER": "Utilisateur",
      "IMAGES": "Images",
      "VIDEOS": "Vidéos",
      "COST": "Coût",
      "MONTH_SELECTOR_LABEL": "Choix du mois",
      "TOTAL": "Total",
      "EMPTY_TITLE": "Aucune consommation",
      "EMPTY_MESSAGE": "L'historique de consommation de votre équipe apparaîtra ici."
    }
  },
  "STORE_SELECTION": {
    "TITLE": "Sélectionnez votre magasin",
    "SUBTITLE": "Choisissez le magasin que vous souhaitez gérer",
    "SEARCH_PLACEHOLDER": "Rechercher par nom, ID, enseigne…",
    "SEARCH_SHORT": "Rechercher…",
    "ALL_BRANDS": "Toutes les enseignes",
    "ALL_TYPES": "Tous les types",
    "RESULTS": "résultats",
    "STORES_LINKED": "magasins rattachés à votre compte",
    "NO_RESULTS": "Aucun magasin trouvé",
    "SEE_ALL": "Voir tous les magasins",
    "SWITCH_STORE": "Changer de magasin",
    "TYPE": {
      "PHYSICAL": "Physique",
      "VIRTUAL": "Virtuel"
    },
    "TABLE": {
      "STORE": "Magasin",
      "STORE_ID": "ID Store",
      "BRAND": "Enseigne",
      "TYPE": "Type",
      "ACTION": "Action",
      "SELECT_STORE": "Sélectionner {{ name }}"
    }
  }
}
